import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  const scrollToContact = (e) => {
    e.preventDefault();
    const el = document.getElementById("contact");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer className="bg-[#10271a] text-[#f6f1e7] relative overflow-hidden">
      <div className="mx-auto max-w-[1400px] px-6 md:px-10 py-16 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <img
              src="/logo-white.png"
              alt="Leslie West Africa Trading Company"
              className="h-14 w-auto mb-6"
            />
            <p className="font-display text-2xl md:text-3xl leading-snug max-w-sm">
              From Pacific gardens and West African soil to the world's <em className="italic text-[#b08a5f]">finest tables.</em>
            </p>
          </div>

          <div className="md:col-span-3 md:col-start-8">
            <h4 className="text-[11px] tracking-[0.2em] uppercase text-[#b08a5f] mb-5">Explore</h4>
            <ul className="space-y-3 text-sm text-[#f6f1e7]/80">
              <li><Link to="/trading/coffee" className="link-underline hover:text-[#f6f1e7]">Coffee &amp; Trading</Link></li>
              <li><Link to="/wholesale" className="link-underline hover:text-[#f6f1e7]">Wholesale Enquiry</Link></li>
              <li><Link to="/security" className="link-underline hover:text-[#f6f1e7]">Security &amp; Consulting</Link></li>
              <li><a href="#contact" onClick={scrollToContact} className="link-underline hover:text-[#f6f1e7]">Make an Enquiry</a></li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <h4 className="text-[11px] tracking-[0.2em] uppercase text-[#b08a5f] mb-5">Trade</h4>
            <ul className="space-y-3 text-sm text-[#f6f1e7]/80">
              <li><Link to="/trading/coffee" className="link-underline hover:text-[#f6f1e7]">PNG Coffee</Link></li>
              <li><Link to="/trading/cocoa" className="link-underline hover:text-[#f6f1e7]">Bougainville Cocoa</Link></li>
              <li><Link to="/trading/vanilla" className="link-underline hover:text-[#f6f1e7]">Sepik Vanilla</Link></li>
              <li><Link to="/trading/wine" className="link-underline hover:text-[#f6f1e7]">South African Wine</Link></li>
              <li>Champagne Lanson</li>
              <li>West African Rice</li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-[#f6f1e7]/15 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-xs tracking-wide text-[#f6f1e7]/55">
          <p>© {new Date().getFullYear()} Leslie West Africa Trading Company. All rights reserved. · <Link to="/admin/login" className="hover:text-[#f6f1e7]" data-testid="footer-admin-link">Trade desk login</Link></p>
          <p className="tracking-[0.18em] uppercase">Sourced directly · Traded responsibly</p>
        </div>
      </div>
    </footer>
  );
}
